import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'

export const useCanReadVehicleTelemetry = () =>
  useUserHasAccess({ requiredRights: [BoumRight.FLEET_VEHICLE_R] })
